import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.253 10.145c.691 0 1.252.56 1.252 1.252v1.206a1.252 1.252 0 1 1-2.505 0v-1.206c0-.691.56-1.252 1.253-1.252M19.748 10.145c.691 0 1.252.56 1.252 1.252v1.206a1.252 1.252 0 1 1-2.505 0v-1.206c0-.691.56-1.252 1.252-1.252M8.126 6.528c.692 0 1.253.56 1.253 1.252v3.944a1.252 1.252 0 1 1-2.505 0V7.78c0-.692.56-1.252 1.252-1.252m0 7.234c.692 0 1.253.561 1.253 1.253v1.206a1.252 1.252 0 1 1-2.505 0v-1.206c0-.692.56-1.253 1.252-1.253M15.874 6.527c.691 0 1.252.561 1.252 1.253v1.206a1.253 1.253 0 0 1-2.505 0V7.78c0-.692.561-1.253 1.253-1.253m0 4.497c.691 0 1.252.56 1.252 1.252v3.944a1.253 1.253 0 0 1-2.505 0v-3.944c0-.691.561-1.252 1.253-1.252M12 3c.692 0 1.252.56 1.252 1.253v1.205a1.253 1.253 0 0 1-2.504 0V4.253C10.748 3.56 11.308 3 12 3m0 4.532c.692 0 1.252.561 1.252 1.253v6.43a1.253 1.253 0 0 1-2.504 0v-6.43c0-.692.56-1.253 1.252-1.253m0 9.757c.692 0 1.252.561 1.252 1.253v1.206a1.253 1.253 0 0 1-2.504 0v-1.206c0-.692.56-1.253 1.252-1.253",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }